import { render, staticRenderFns } from "./IndexEmpty.vue?vue&type=template&id=0d10fa80&"
import script from "./IndexEmpty.vue?vue&type=script&lang=js&"
export * from "./IndexEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports